import { render, staticRenderFns } from "./panoramic-hotel.vue?vue&type=template&id=6f148b9a&scoped=true"
import script from "./panoramic-hotel.vue?vue&type=script&lang=js"
export * from "./panoramic-hotel.vue?vue&type=script&lang=js"
import style0 from "./panoramic-hotel.vue?vue&type=style&index=0&id=6f148b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f148b9a",
  null
  
)

export default component.exports